import moment from 'moment'
import { APIFactory } from '../api/api.factory'
import DateService from '../services/DateService'

const ExpenseReportAPI = APIFactory.get('expenseReport')
const LodgeAPI = APIFactory.get('lodge');


//Internal only not accessible by default export. 
const setIsExceptionSatisifed = function (ex) {
    ex.isSatisfied = false;

    //over per diem, selected none for per diem overage
    if (ex.expenseExceptionTypeId == 1 && ex.responseValue == 2) {
        return ex.isSatisfied = true;
    }

    //over per diem,has a option other than none selected, has atleast one attachment.
    if (ex.expenseExceptionTypeId == 1) {
        if (ex.responseValue == 3 || ex.responseValue == 4 || ex.responseValue == 5 || ex.responseValue == 6) {
            if (ex.attachments.length >= 1) {
                return ex.isSatisfied = true;
            }
        }
    }
    //personal day exception, has a response value, has atleast one attachment
    if (ex.expenseExceptionTypeId == 2 && ex.responseValue && ex.attachments.length >= 1) {
        return ex.isSatisfied = true;
    }

    //otherwise default to exception has not been satisified.
}


export default {

    async getLodges(erID) {
        console.log('lodgingservice.getLodges')
        const { data } = await LodgeAPI.get(erID);

        return data;
    },

    async saveLodge(request) {
        console.log('lodgingservice.saveLodge')
        const { data } = await LodgeAPI.save(request);

        return data;
    },
    async getLodgeLocationSummary(erID) {
        console.log('lodgingservice.getLodgeLocationSummary')
        const { data } = await ExpenseReportAPI.getLodgeLocationSummary(erID);

        return data;
    },

    async getReferenceDates(erID) {
        console.log('lodgingservice.getReferenceDates')
        const { data } = await ExpenseReportAPI.getReferenceDates(erID);

        return data;
    },
    async deleteLodge(id) {
        console.log('lodgingservice.deleteLodge');
        const { data } = await LodgeAPI.delete(id);
        return data;

    },
    mapResponseToHotel(existingLodging) {
        console.log('lodgingservice.mapResponseToHotel')
        let tripHotels = [];

        existingLodging.forEach(el => {
            let hoteldays = []

            //this area map resposne back to object and join them together
            el.lodgeDates.forEach(ld => {
                hoteldays.push({
                    //vueJSUniqueID: this.randomID(),
                    hotelDate: DateService.normalizeDateTime(ld.date),
                    base: ld.amount,
                    taxes: ld.tax,
                    total: 0,
                    adjustment: ld.adjustment,
                    baseOverThreeTimesAdjustment: 0,
                    taxesOverThreeTimesAdjustment: 0,
                    baseWarning: false,
                    personalDay: false,
                    exception: false,
                    exceptions: ld.exceptions,
                    exceptionSatisfied: false,
                    id: ld.id,
                    lodgeId: ld.lodgeId
                })
            })

            //ensure order of items is least to greatest on table
            hoteldays = _.orderBy(hoteldays, 'hotelDate', 'asc')

            let hotel = {
                hotelName: el.lodgeName,
                attachments: el.attachments,
                startDate: moment(DateService.normalizeDateTime(el.startDate)).toDate(),
                endDate: moment(DateService.normalizeDateTime(el.endDate)).toDate(),
                hotelDayDates: hoteldays,
                baseSubTotal: 0,
                baseAdjustment: 0,
                taxesSubTotal: 0,
                taxesAdjustment: 0,
                adjustmentTotal: 0,
                subTotal: 0,
                total: 0,
                mergeExceptions: el.mergeExceptions,
                id: el.id
            };

            //hotel.hotelDayDates.forEach(hd => this.calculateHotelDayTotal(tempHotel, hd))
            tripHotels.push(hotel)
        })
        return tripHotels;
    },
    createSaveRequest(hotels, expenseReportID, supportingRemark) {
        let listOfLodges = [];
        let lodgeRequest = {
            expenseReportId: expenseReportID,
            lodges: listOfLodges,
            supportingRemark: supportingRemark
        }

        hotels.forEach(m => {
            let lDates = [];
            m.hotelDayDates.forEach(hDD => {

                hDD.exceptions.forEach(ex => { setIsExceptionSatisifed(ex); ex.responseValue = ex.responseValue ? ex.responseValue.toString() : ex.responseValue; });

                lDates.push(
                    {
                        "lodgeId": hDD.lodgeId,
                        "date": DateService.normalizeDateTime(hDD.hotelDate),
                        "amount": hDD.base,
                        "tax": hDD.taxes,
                        "adjustment": hDD.adjustment,
                        "exceptions": hDD.exceptions,
                        "id": hDD.id
                    })
            })

            listOfLodges.push(
                {
                    "expenseReportId": expenseReportID,
                    "lodgeName": m.hotelName,
                    "attachments": m.attachments,
                    "startDate": DateService.normalizeDateTime(m.startDate),
                    "endDate": DateService.normalizeDateTime(m.endDate),
                    "id": m.id,
                    "lodgeDates": lDates,
                    "mergeExceptions": m.mergeExceptions
                })
        })

        return lodgeRequest;
    }
}